// src/store/slices/leadProfileSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LeadProfileState {
    selectedView: string;
}

const initialState: LeadProfileState = {
    selectedView: '/info',
};

const leadProfileSlice = createSlice({
    name: 'leadProfile',
    initialState,
    reducers: {
        setSelectedView(state, action: PayloadAction<string>) {
            state.selectedView = action.payload;
        },
    },
});

export const { setSelectedView } = leadProfileSlice.actions;
export default leadProfileSlice.reducer;